import * as Styles from './styles';
import Edit from '@/assets/Icons/edit-pencil.svg';
import Default from '@/assets/Icons/default_car.svg';
import { IVehicleDetails } from '@/types';
import { getFormattedRegNo } from '@/utils';
import Router from '@/components/common/router';
import { ROUTEMAP } from '../../constants';
import useQueryParam from '@/hooks/useQueryParam';
import { resolvePath } from '@/utils/resolvePath';
import { getIconFromMake } from '../../utils';
import { useRouter } from 'next/router';

interface CarCardProps {
    carData: IVehicleDetails;
    onClick: () => void;
    active?: boolean;
}

export function CarCard({
    carData,
    onClick = () => {},
    active = false,
}: CarCardProps) {
    //this is to ensure both old and new flows are working
    const router = useRouter();
    const pageType = useQueryParam(`redirect_from`) || '';
    function handleEditClick() {
        // @TODO: Modify route and search accordingly when its ready
        sessionStorage.setItem(
            'registration_number',
            carData.vehicle_number as string
        );
        localStorage.setItem(
            'registration_number',
            carData.vehicle_number as string
        );
        const queryParams = buildMMVQueryString(carData);
        const garageId = localStorage.getItem('garage_id');
        const hasGarageId = 'garageId' in router.query;
        let finalQueryParams = queryParams;
        if (!hasGarageId && garageId) {
            finalQueryParams = queryParams
                ? `${queryParams}&garageId=${garageId}`
                : `garageId=${garageId}`;
        }
        Router.push(
            `${ROUTEMAP.MMV}${
                finalQueryParams ? `?${finalQueryParams}` : ''
            }&redirect_from=${pageType}&is_edit=true`
        );
    }
    const carDetails = [
        carData?.variant_name,
        carData?.fuel_type?.toLocaleUpperCase(),
    ]
        .filter(Boolean)
        .join(' • ');
    const vehicleImage = getIconFromMake(carData?.vehicle_make);
    return (
        <Styles.CardWrapper active={active}>
            <Styles.ContentWrapper onClick={onClick}>
                <Styles.CardContentLeft>
                    <Styles.Title>
                        {carData?.vehicle_make} {carData?.vehicle_model || ''}
                    </Styles.Title>
                    <Styles.RegNo>
                        {getFormattedRegNo(
                            carData?.vehicle_number || ''
                        )?.toUpperCase()}
                    </Styles.RegNo>
                    {carDetails && (
                        <Styles.CarDetails>{carDetails}</Styles.CarDetails>
                    )}
                </Styles.CardContentLeft>
                <Styles.CardContentRight>
                    {carData?.photo ? (
                        <Styles.ImageData src={carData?.photo} />
                    ) : vehicleImage !== '' ? (
                        <Styles.ImageData src={resolvePath(vehicleImage)} />
                    ) : (
                        <Default />
                    )}
                </Styles.CardContentRight>
            </Styles.ContentWrapper>
            <Styles.CardBottom>
                {carData?.variant && carData.fuel_type && (
                    <Styles.OtherData>
                        {carData?.variant} • {carData?.fuel_type} •{' '}
                        {carData?.registration_year}
                    </Styles.OtherData>
                )}
                <Styles.Edit onClick={handleEditClick}>
                    <Edit />
                    Edit
                </Styles.Edit>
            </Styles.CardBottom>
        </Styles.CardWrapper>
    );
}

interface CarData {
    vehicle_model?: string;
    vehicle_make?: string;
    variant_name?: string;
    fuel_type?: string;
    vehicle_number?: string;
}

export const buildMMVQueryString = ({
    vehicle_model = '',
    vehicle_make = '',
    variant_name = '',
    fuel_type = '',
    vehicle_number = '',
}: CarData) => {
    const queryParamsObj: any = {};

    if (vehicle_model) queryParamsObj.model = vehicle_model;
    if (vehicle_make) queryParamsObj.make = vehicle_make;
    if (variant_name) queryParamsObj.variant = variant_name;
    if (fuel_type) queryParamsObj.fuel_type = fuel_type;
    if (vehicle_number) queryParamsObj.carnumber = vehicle_number;

    return new URLSearchParams(queryParamsObj).toString();
};
